var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shopIdCell"},[_c('el-tooltip',{directives:[{name:"ak-tooltip-auto-show",rawName:"v-ak-tooltip-auto-show"}],attrs:{"placement":"top","content":_vm.row[_vm.column.key]}},[_c('span',{staticClass:"line-ellipsis-1 yx-color-pure-1",staticStyle:{"width":"100%"}},[_vm._v(_vm._s(_vm._f("formatEmpty")(_vm.row[_vm.column.key])))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }